module.exports = __webpack_public_path__ + "media/src/application/media/v2-icon-3-a2cbb0f4da24a7bf4164be0c69f8a27f.svg";